// extracted by mini-css-extract-plugin
module.exports = {"airline":"airline-mMNeY","airline__number":"airline__number-1qyjQ","airline__name":"airline__name-3qSAw","aircraft__name_active":"aircraft__name_active-2UJnb"};